<template>
    <div class="d-flex justify-content-center flex-wrap">
        <div class="col-12 col-md-8 col-lg-6">
            <div class="mb-4">
                <h1 class="fw-bold">
                    {{ $t(`Auth.${this.$route.name}.RouteName`) }}
                </h1>
            </div>
            <form @submit.prevent="signUp" class="bg-white p-4 mb-5">
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input type="text" ref="name" id="name" :class="{'text-danger' : errors.name}" required>
                        <label for="name" :class="{'text-danger' : errors.name}">
                            {{ $t('Auth.SignUp.name') }}
                            <small class="text-danger" v-if="errors.name">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.name }}
                            </small>
                        </label>
                    </div>
                </div>
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input type="text" ref="surname" id="surname" :class="{'text-danger' : errors.surname}" required>
                        <label for="surname" :class="{'text-danger' : errors.surname}">
                            {{ $t('Auth.SignUp.surname') }}
                            <small class="text-danger" v-if="errors.surname">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.surname }}
                            </small>
                        </label>
                    </div>
                </div>
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input type="text" ref="email" id="email" :class="{'text-danger' : errors.email}" required>
                        <label for="email" :class="{'text-danger' : errors.email}">
                            {{ $t('Auth.SignUp.email') }}
                            <small class="text-danger" v-if="errors.email">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.email }}
                            </small>
                        </label>
                    </div>
                </div>
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input type="text" ref="confirm_email" id="confirm_email" :class="{'text-danger' : errors.confirm_email}" required>
                        <label for="confirm_email" :class="{'text-danger' : errors.confirm_email}">
                            {{ $t('Auth.SignUp.confirm_email') }}
                            <small class="text-danger" v-if="errors.confirm_email">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.confirm_email }}
                            </small>
                        </label>
                    </div>
                </div>
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input :type="passwordShowed === false ? 'password' : 'text'" ref="password" id="password" :class="{'text-danger' : errors.password}" required>
                        <label for="password" :class="{'text-danger' : errors.password}">
                            {{ $t('Auth.SignUp.password') }}
                            <small class="text-danger" v-if="errors.password">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.password }}
                            </small>
                        </label>
                        <span class="position-absolute top-50 end-0 translate-middle opacity-50" role="button" @click="passwordShowed = !passwordShowed">
                            <i class="fa-solid" :class="passwordShowed ? 'fa-eye' : 'fa-eye-slash'"></i>
                        </span>
                    </div>
                </div>
                <div class="form-field mb-4">
                    <div class="field-wrapper">
                        <input :type="confirmPasswordShowed === false ? 'password' : 'text'" ref="confirm_password" id="confirm_password" :class="{'text-danger' : errors.confirm_password}" required>
                        <label for="confirm_password" :class="{'text-danger' : errors.confirm_password}">
                            {{ $t('Auth.SignUp.confirm_password') }}
                            <small class="text-danger" v-if="errors.confirm_password">
                                <span class="mx-2">
                                    -
                                </span>
                                {{ errors.confirm_password }}
                            </small>
                        </label>
                        <span class="position-absolute top-50 end-0 translate-middle opacity-50" role="button" @click="confirmPasswordShowed = !confirmPasswordShowed">
                            <i class="fa-solid" :class="confirmPasswordShowed ? 'fa-eye' : 'fa-eye-slash'"></i>
                        </span>
                    </div>
                </div>
                <div class="form-field text-center mb-4">
                    <LanguagesSelect id="language" @setLanguage="errors = {}"/>
                </div>
                <div class="form-field text-center mb-5">
                    <label class="switch me-2">
                        <input type="checkbox" v-model="privacy" @change="errors.privacy = null"/>
                        <span class="slider round"></span>
                    </label>
                    <a href="https://atb.bergamo.it/il-gruppo/privacy" target="_blank" class="text-underline" :class="errors.privacy ? 'text-danger' : 'text-second'">
                        {{ $t('Auth.SignUp.privacy') }}
                    </a>
                    <small class="text-danger" v-if="errors.privacy">
                        <span class="mx-2">
                            -
                        </span>
                        {{ errors.privacy }}
                    </small>
                </div>
                <div class="d-flex justify-content-between align-items-center flex-wrap text-end">
                    <router-link to="/" class="text-first text-decoration-underline">
                        {{ $t('Auth.SignUp.go_back') }}
                    </router-link>
                    <button type="submit" class="btn btn-lg btn-auth btn-auth-first">
                        {{ $t('Auth.SignUp.sign_up') }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import LanguagesSelect from '@/components/LanguagesSelect.vue'
export default {
    name: 'SignUp',
    components: {
        LanguagesSelect
    },
    computed: {
        ...mapGetters(['apiPath', 'omsApiKey']),
    },
    data() {
        return {
            passwordShowed: false,
            confirmPasswordShowed: false,
            privacy: false,
            errors: {}
        }
    },
    methods: {
        ...mapMutations(['setErrorFromServer']),
        signUp() {
            this.errors = {}
            if (this.privacy === false) {
                this.errors.privacy = this.$t('Auth.SignUp.errors.privacy.required')
                this.$toast.error(this.$t('toast.fields_errors'))
                return
            }
            this.$http
                .post(`${this.apiPath}/sign_up`, { user: {
                    name: this.$refs.name.value,
                    surname: this.$refs.surname.value,
                    date_of_birth: null,
                    email: this.$refs.email.value,
                    confirm_email: this.$refs.confirm_email.value,
                    password: this.$refs.password.value,
                    confirm_password: this.$refs.confirm_password.value,
                    language: this.$i18n.locale,
                }}, {
                    headers: {
                        'x-api-key': this.omsApiKey
                    }
                })
                .then((res) => {
                    if (res.data.errors) {
                        var errors = res.data.errors
                        for (var i = 0; i < errors.length; i++) {
                            var error = errors[i]
                            if (error.path == 'user.name') {
                                this.errors.name = this.$t(`Auth.SignUp.errors.name.${error.msg}`)
                            }
                            if (error.path == 'user.surname') {
                                this.errors.surname = this.$t(`Auth.SignUp.errors.surname.${error.msg}`)
                            }
                            if (error.path == 'user.email') {
                                this.errors.email = this.$t(`Auth.SignUp.errors.email.${error.msg}`)
                            }
                            if (error.path == 'user.confirm_email') {
                                this.errors.confirm_email = this.$t(`Auth.SignUp.errors.confirm_email.${error.msg}`)
                            }
                            if (error.path == 'user.password') {
                                this.errors.password = this.$t(`Auth.SignUp.errors.password.${error.msg}`)
                            }
                            if (error.path == 'user.confirm_password') {
                                this.errors.confirm_password = this.$t(`Auth.SignUp.errors.confirm_password.${error.msg}`)
                            }
                            if (error.path == 'user.language') {
                                this.errors.language = this.$t(`Auth.SignUp.errors.language.${error.msg}`)
                            }
                        }
                        this.$toast.error(this.$t('toast.fields_errors'))
                    } else {
                        switch (res.data) {
                            case 'Account Already Exists':
                                this.errors.email = this.$t('Auth.SignUp.errors.email.AccountAlreadyExists')
                                this.$toast.error(this.$t('Auth.SignUp.errors.email.AccountAlreadyExists'))
                                break
                            case 'Account Registered Successfully':
                                this.$http
                                    .post(`${this.apiPath}/email/send_email_confirmation_request`, { email: this.$refs.email.value }, {
                                        headers: {
                                            'x-api-key': this.omsApiKey
                                        }
                                    }).then((res) => {
                                        this.$toast.success(`<h4>${this.$t('toast.signup_succeeded')}</h4> ${this.$t('toast.sent_email')} <strong>${res.data.data.to}</strong> <h6>${this.$t('toast.confirm_email')}</h6>`)
                                        this.$router.replace('/')
                                    })
                                    .catch((err) => {
                                        this.setErrorFromServer(err.message)
                                    })
                                break
                        }
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        }
    }
}
</script>